import { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Fixed time ranges that correspond to pre-computed BigQuery analysis
// These match the scheduled queries: 7d, 30d, 60d, 90d
const PRESET_RANGES = [
  { value: '7d', label: 'Last 7 Days', days: 7 },
  { value: '30d', label: 'Last 30 Days', days: 30 },
  { value: '60d', label: 'Last 60 Days', days: 60 },
  { value: '90d', label: 'Last 90 Days', days: 90 }
];

export default function TimeFrameSelector({ value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);

  // Find current preset - default to 90 days (matches BigQuery scheduled query)
  const currentPreset = PRESET_RANGES.find(r => r.value === value?.preset) || PRESET_RANGES[3]; // Default to 90 days (index 3)

  const handleToggle = (nextShow) => {
    setIsOpen(nextShow);
  };

  const handlePresetSelect = (preset) => {
    setIsOpen(false);
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - preset.days);

    onChange({
      preset: preset.value,
      label: preset.label,
      days: preset.days,
      startDate,
      endDate
    });
  };

  return (
    <Dropdown show={isOpen} onToggle={handleToggle}>
      <Dropdown.Toggle variant="outline-secondary" size="sm" className="d-flex align-items-center">
        <FontAwesomeIcon icon="calendar-alt" className="me-2" />
        {value?.label || currentPreset.label}
      </Dropdown.Toggle>

      <Dropdown.Menu className="p-2" style={{ minWidth: '200px' }}>
        {/* Preset Options - correspond to pre-computed BigQuery analyses */}
        <div className="mb-2">
          <small className="text-muted fw-semi-bold px-2">Time Range</small>
        </div>
        {PRESET_RANGES.map(preset => (
          <Dropdown.Item
            key={preset.value}
            active={currentPreset.value === preset.value}
            onClick={() => handlePresetSelect(preset)}
          >
            {preset.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
